module.exports = "<router-outlet></router-outlet>\n<div class=\"app\" [ngxInactivity]=\"1\" (ngxInactivityCallback)=\"handleInactivityCallback()\"></div>\n"